import type { AxiosRequestConfig } from "axios";
import {
  http,
  getInboxEndpoint,
  getTrackingEndpoint,
  InboxCancelRequest,
} from "@/services";
import type { QueryParamsForGetRequest } from "@/utils/types";
import { appendQueryToUrl } from "@/utils";
import {
  getCancelRequestEndpoint,
  getRequestEndpoint,
  getUpdateRequestEndpoint,
  RequestResponse,
  UpdateRequestPayload,
} from "@/services/api";
import type { InboxFlatResponse, TrackingFlatResponse } from "./contracts";

export interface InboxPayload {
  email: string;
  filters?: string | string[];
  filterText?: string;
  pageNumber: number;
  pageSize: number;
  isFlatResponse?: boolean;
}

export const requestApprovalsList = (
  {
    email,
    filters,
    filterText,
    pageNumber,
    pageSize,
    isFlatResponse = false,
  }: InboxPayload,
  config?: AxiosRequestConfig,
): Promise<InboxFlatResponse> =>
  http.get<InboxFlatResponse>(
    getInboxEndpoint,
    { email, filters, filterText, pageNumber, pageSize },
    config,
    undefined,
    undefined,
    isFlatResponse,
  );

export const requestTrackingList = (
  {
    email,
    filters,
    filterText,
    pageNumber,
    pageSize,
    isFlatResponse = false,
  }: InboxPayload,
  config?: AxiosRequestConfig,
): Promise<TrackingFlatResponse> =>
  http.get<TrackingFlatResponse>(
    getTrackingEndpoint,
    { email, filters, filterText, pageNumber, pageSize },
    config,
    undefined,
    undefined,
    isFlatResponse,
  );

export const cancelInboxRequest = (
  { email, requestId }: QueryParamsForGetRequest,
  config?: AxiosRequestConfig,
): Promise<InboxCancelRequest> => {
  const url = appendQueryToUrl(getCancelRequestEndpoint, { email, requestId });

  return http.put<InboxCancelRequest>(url, undefined, config, undefined);
};

export const submitInboxRequest = (
  { email, loaRequestUpdateDto }: UpdateRequestPayload,
  config?: AxiosRequestConfig,
): Promise<unknown> => {
  const url = appendQueryToUrl(getUpdateRequestEndpoint, { email });

  return http.post(url, { loaRequestUpdateDto }, config);
};

export const requestInboxDetails = (
  {
    email,
    referenceNumber,
    domainId,
  }: { email: string; referenceNumber: string; domainId: string },
  config?: AxiosRequestConfig,
): Promise<{ Data: RequestResponse }> =>
  http.get<{ Data: RequestResponse }>(
    getRequestEndpoint,
    { email, id: referenceNumber, domainId },
    config,
    undefined,
    undefined,
    false,
  );
